export const perfilChangeLinkedin = {
  "LinkedIn": "LinkedIn",
  "Fechar": "Close",
  "Aviso": "Warning",
  "Dados atualizado com sucesso.": "Data updated successfully.",
  "Por favor, informe um perfil válido. Caso não saiba como, acesse o linkedin, clique em visualizar perfil e copie a url do navegador.": "Please provide a valid profile. If you dont know how, access LinkedIn, click on view profile and copy the URL from the browser.",
  "Whatsapp": "Whatsapp",
  "Salvar": "Save",
  "Campo obrigatório.": "Required field."
};


// WEBPACK FOOTER //
// ./src/resources/enUS/perfilChangeLinkedin.js